var React = require('react');

function Stroke4Green (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#7DB343","strokeWidth":"13","d":"M-24 146C108 57 223 11 322 8c148-6 459 89 654 98 194 8 466-43 534-71"}));
}

Stroke4Green.defaultProps = {"viewBox":"0 0 1440 138"};

module.exports = Stroke4Green;

Stroke4Green.default = Stroke4Green;
